import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Copy, Download, Loader } from 'lucide-react';

const ContentEditor = ({ content, onContentChange, platform, isGenerating }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(content);
  };

  const handleDownload = () => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `content-${platform}-${Date.now()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold text-lg flex items-center gap-2">
          <FileText size={20} className="text-cyan-400" />
          Contenu généré
        </h3>
        <div className="flex gap-2">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleCopy}
            className="p-2 bg-white/5 rounded-lg hover:bg-white/10 transition-colors"
            title="Copier"
            data-testid="copy-button"
          >
            <Copy size={18} className="text-slate-400" />
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleDownload}
            className="p-2 bg-white/5 rounded-lg hover:bg-white/10 transition-colors"
            title="Télécharger"
            data-testid="download-button"
          >
            <Download size={18} className="text-slate-400" />
          </motion.button>
        </div>
      </div>

      <textarea
        value={content}
        onChange={(e) => onContentChange(e.target.value)}
        placeholder="Le contenu généré par l'IA apparaîtra ici. Vous pouvez le modifier à votre guise..."
        className="w-full h-96 px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/50 transition-all resize-none"
        data-testid="content-editor"
      />

      {isGenerating && (
        <div className="mt-4 flex items-center gap-2 text-cyan-400 text-sm">
          <Loader className="animate-spin" size={16} />
          <span>Génération en cours...</span>
        </div>
      )}

      <div className="mt-4 flex items-center justify-between text-sm">
        <span className="text-slate-400">Caractères: {content.length}</span>
        <span className="text-slate-400">Plateforme: {platform}</span>
      </div>
    </div>
  );
};

export default ContentEditor;
